import React from "react";
import AnalyticsCards from "../../components/Cards/AnalyticsCards";
import OverviewChart from "../../components/Charts/OverviewChart";

const Dashboard = () => {
  return (
    <>
      <AnalyticsCards />
      <OverviewChart />
    </>
  );
};

export default Dashboard;
